import { render, staticRenderFns } from "./RelatedNews.vue?vue&type=template&id=0b7c2d42&scoped=true&"
import script from "./RelatedNews.vue?vue&type=script&lang=js&"
export * from "./RelatedNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c2d42",
  null
  
)

export default component.exports